<script setup>
import { onMounted, computed } from 'vue';
import { useGlobalStore } from '/store/global';

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();

onMounted(() => {
  // Application démarrée
});

// Show admin button when NOT on /admin routes (same position on all pages including quote pages)
const showAdminButton = computed(() => !route.path.startsWith('/admin'));

const goToAdmin = () => {
  router.push('/admin');
};
</script>

<template>
  <div>
    <!-- Admin button - fixed position, outside all containers, hidden on mobile -->
    <v-btn
      v-if="showAdminButton"
      @click="goToAdmin"
      variant="tonal"
      color="primary"
      size="small"
      icon="mdi-account-cog"
      class="global-admin-button rounded-lg d-none d-md-flex"
    ></v-btn>

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <!-- Notification globale unique -->
    <v-snackbar
      v-model="globalStore.notification.show"
      :color="globalStore.notification.type === 'error' ? 'error' : globalStore.notification.type"
      :location="globalStore.notification.type === 'error' ? 'top' : 'bottom right'"
      :timeout="globalStore.notification.type === 'error' ? -1 : 3000"
      :multi-line="globalStore.notification.type === 'error'"
      :class="globalStore.notification.type === 'error' ? 'global-error-snackbar' : ''"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">{{ globalStore.notification.icon || 'mdi-check-circle' }}</v-icon>
        <span class="flex-grow-1">{{ globalStore.notification.message }}</span>
        <v-btn
          v-if="globalStore.notification.type === 'error'"
          icon="mdi-close"
          variant="text"
          size="small"
          @click="globalStore.hideNotification()"
          class="ml-2"
        ></v-btn>
      </div>
    </v-snackbar>
  </div>
</template>
<style>
:root {
  --v-theme-primary: 242, 124, 56;

}

/*TODO: mettre au bon endroit ? */
.v-theme--myQuoteTheme {
  --v-disabled-opacity: 0.7 !important;
}

/* Suppression du border-radius sur tous les inputs */
.v-field--variant-outlined .v-field__outline__start {
  border-radius: 0 !important;
}

.v-field--variant-outlined .v-field__outline__end {
  border-radius: 0 !important;
}

.v-field__outline__end {
  border-radius: 0 !important;
}

.v-field {
  border-radius: 0 !important;
}

.v-text-field .v-field {
  border-radius: 0 !important;
}

.v-data-table td{
  word-break: break-word;
}

.mobile {
  width: 100%;
  min-height: 100vh;
  margin: 0;
}

/* Conteneur spécifique pour les pages devis - largeur centralisée */
.quote-container {
  width: 100%;
  min-height: 100vh;
  margin: 0;

  /* Header et Footer des pages devis s'adaptent automatiquement */
  .fixed_header,
  .v-bottom-navigation {
    width: 100%;
  }
}

/* Desktop constraints - limit width and center on larger screens */
@media (min-width: 960px) {
  .mobile {
    max-width: 400px;
    margin: 0 auto;
    border-left: 0.5px solid rgba(0, 0, 0, 0.2);
    border-right: 0.5px solid rgba(0, 0, 0, 0.2);
  }

  .quote-container {
    max-width: 400px;
    margin: 0 auto;
    border-left: 0.5px solid rgba(0, 0, 0, 0.2);
    border-right: 0.5px solid rgba(0, 0, 0, 0.2);

    .fixed_header,
    .v-bottom-navigation {
      max-width: 400px;
    }
  }
}

::before,
::after {

  text-decoration: inherit;
  vertical-align: inherit;

}

@media (min-width: 960px) and (max-width: 1280px) {
  .v-container {
    max-width: none;
  }

}

.v-btn--variant-text .v-btn__overlay {
  background: transparent !important;
}

/* Global admin button - fixed position outside mobile container, hidden on mobile */
.global-admin-button {
  position: fixed !important;
  top: 16px;
  right: 16px;
  z-index: 9999 !important;
}

/* Hide on mobile, show on desktop */
@media (max-width: 959px) {
  .global-admin-button {
    display: none !important;
  }
}

@media (min-width: 960px) {
  .global-admin-button {
    display: flex !important;
  }
}

/* Hide on mobile, show on desktop */
@media (max-width: 959px) {
  .global-admin-button {
    display: none !important;
  }
}

@media (min-width: 960px) {
  .global-admin-button {
    display: flex !important;
  }
}

/* Style global harmonisé pour tous les accordéons */
.v-expansion-panel-title {
  font-size: 1rem !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.87) !important;
  min-height: 48px !important;
  padding: 12px 16px !important; /* Padding interne pour éviter que le texte soit collé */
}

.v-expansion-panel-text {
  padding: 0 !important;
}

.v-expansion-panel-text :deep(.v-expansion-panel-text__wrapper) {
  padding: 16px !important; /* Padding vertical et horizontal */
}

.v-expansion-panels {
  border-radius: 0 !important;
}

.v-expansion-panel {
  border-radius: 0 !important;
}

/* ==========================================================================
   NOTIFICATION GLOBALE - Snackbar d'erreur pleine largeur
   ========================================================================== */
.global-error-message {
  flex: 1;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.5;
}

.global-error-snackbar .v-snackbar__wrapper {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
}

.global-error-snackbar .v-snackbar__content {
  width: 100% !important;
  padding: 16px 24px !important;
}

@media (min-width: 600px) {
  .global-error-snackbar .v-snackbar__wrapper {
    max-width: 800px !important;
    margin: 8px auto !important;
    border-radius: 8px !important;
  }
}
</style>